import React from 'react';
import { Achievement } from '@/types/achievements';
import { AchievementCard } from './AchievementCard';

interface AchievementCategoryProps {
  title: string;
  achievements: Achievement[];
}

export const AchievementCategory: React.FC<AchievementCategoryProps> = ({
  title,
  achievements
}) => {
  if (achievements.length === 0) return null;

  return (
    <div className="mb-8">
      <h2 className="text-base font-medium mb-4 px-2">{title}</h2>
      <div className="flex flex-wrap gap-4">
        {achievements.map((achievement) => (
          <div key={achievement.id} className="w-[calc(33.33%-1rem)] min-w-[90px] max-w-[110px]">
            <AchievementCard
              achievement={achievement}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
